import React from 'react';
import { number, string } from 'prop-types';
import { Rule } from './horizontal-rule.styles';

const HorizontalRule = props => /*#__PURE__*/React.createElement(Rule, props);

process.env.NODE_ENV !== "production" ? HorizontalRule.propTypes = {
  size: number,
  bg: string
} : void 0;
HorizontalRule.defaultProps = {
  size: 1,
  bg: 'border.light'
};
export default HorizontalRule;